import { graphql } from "@/lib/gql/__generated__";

export const HpbPageDelete_HpbListPage_Mutation = graphql(`
	mutation HpbPageDelete_HpbListPage($hotelID: ID!, $uuid: ID!) {
		hpbPageDelete(hotelID: $hotelID, uuid: $uuid) {
			userErrors
			hpbPage {
				id
				uuid
				hotelID
				slug
				title
				description
				thumbnail
				studio {
					bucket
					key
					region
					mimeType
					fileName
				}
				staticPageType
				createdAt
				updatedAt
				deletedAt
			}
		}
	}
`);
